import React, { useState, useEffect } from "react";
import classes from './ServicesInventionsScheme.module.scss'
import { tabserv } from '../../../../assets/db'
import Schame from "../../../../components/Schame";
import { useOutletContext } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import Loader from "../../../../containers/Loader";
export default function ServicesInventionsScheme() {
    const [parant] = useOutletContext();
    const [childLoading, childData, childError] = useFetch(`/content/all/service?lang=ru&parent=${parant}`)
    const [array, setArray] = useState([])
    // useEffect(()=>{
    //     if(childData.data){
    //       let array =   childData.data.filter(el => el.slug === 'cxema-uslugi-2')
    //       setArray(array)
    //     }

    // },[childData.data])
    console.log(childData);
    if (childLoading) return <Loader />
    return (
        <>
            {
                childData.data && childData.data ? (
                    <Schame obj={childData.data} />
                ) : (
                    ''
                )
            }
        </>
    )
}